@if (card) {
  <accordion [openByDefault]="openByDefault" [allowCollapse]="allowCollapse" [ariaLabel]="floorPlanLabel + card.Name">
    <div header>
      <icon [name]="card.IsInventoryHome ? 'inventory_home' : 'floorplan'" [class.is-inventory-home]="card.IsInventoryHome"></icon>
      <h2>{{card.Name}}</h2>
      <favorite-btn [isActive]="card.IsFavorited" (toggle)="handleFavoriteToggle($event)"></favorite-btn>
    </div>
    <div body>
      @if (showNeighborhoodName) {
        <div class="neighborhood-label">
          @if (showNeighborhoodIcon) {
            <icon name="neighborhood"></icon>
            }{{card.NeighborhoodName}}
          </div>
        }
        <div class="card-content">
          <div class="navigation-buttons">
            @if (card.AssociatedLots.length && showLotSelector) {
              @if (card.AssociatedLots.length) {
                <lot-selector [currentLot]="currentLot" [lots]="card.AssociatedLots"
                  [isInventoryHome]="card.IsInventoryHome" (selectLot)="selectLot.emit($event)" (selectAll)="selectAllLots.emit()"
                [lotLabel]="lotLabel" [allLotStatuses]="allLotStatuses"></lot-selector>
              }
            }

            @if (!!staticMediaImages.length) {
              <icon-button class="view-static-gallery-button" icon="camera_frame"
              (click)="handleGalleryImageModal()"></icon-button>
            }
            @if (hasExternalMedia) {
              <icon name="walkthrough" class="external-media-icon"
              matTooltip="Select 'View Floorplan' to explore more media for this plan."></icon>
            }
            @if (showIfpButton) {
              <icon-button class="view-floorplan-button" [ngClass]="{noMediaImages : !hasExternalMedia && !staticMediaImages.length }"
              text="View {{floorPlanLabel}}" [showArrow]="true" (click)="handleNavigateToFloorplan()"></icon-button>
            }
            @if (fullDetailsUrl) {
              <icon-button text="Full Details" (click)="handleClickFullDetails()"></icon-button>
            }
          </div>

          <gallery (domChange)="handleDomChange()" [images]="galleryImages" [isInventoryHomeGallery]="card.IsInventoryHome" [useLetterbox]="useLetterbox"
            (favoriteToggle)="handleImageFavoriteToggle($event)">
          </gallery>

          @if (card.IsInventoryHome && !doneWithHiddenSvgs) {
            <div class="hidden-svg-loader">
              @for (floor of card.Floors; track floor) {
                <div class="transform-receptor" [transformApplier]="graphicsModel">
                  <div class="svg-container" [svgInjector]="floor.FullSvgUrl" (svgLoad)="onFloorLoad(floor, $event)">
                  </div>
                </div>
              }
            </div>
          }

          @if (showFloorplanFeatures) {
            <floorplan-features [floors]="card.Floors" [featuresSettingValue]="featuresSettingValue"
              [description]="card.Description" [infoDescriptionTitle]="infoDescriptionTitle"
            [isInventoryHome]="card.IsInventoryHome"></floorplan-features>
          }
          <floorplan-specs [fp]="card" [forceNonCollapsible]="forceNonCollapsibleSpecs"></floorplan-specs>
        </div>
      </div>
    </accordion>
  }